// extracted by mini-css-extract-plugin
export var autoExpand = "_2f-8";
export var container = "_2f-7";
export var containerWidth = "_2f-5";
export var disabled = "_2f-2";
export var error = "_2f-3";
export var fullWidth = "_2f-6";
export var inputWrapper = "_2f-0";
export var small = "_2f-1";
export var textarea = "_2f-4";